$(document).ready(function () {

    $(document).on('click', '.js-find-freelance-modal-toggle', function (e) {
        $.ajax({
            url: "/jobs/GetFindFreelanceModal",
            success: function (result) {
                $('.js-job-find-freelance-modal').remove();
                $('body').append(result);

                $('.js-job-find-freelance-modal').modal('show');
                initForm();

            }
        });
    });

    $(document).on('hidden.bs.modal', '.js-job-find-freelance-modal', function (e) {
        $(e.target).remove();
    });

    //$('.attachment-upload-section .file-input').on('change.bs.fileinput', function (e) {
    //    e.preventDefault();
    //    if (e.target.files[0]) {
    //        $(this).parent('.input-addon').hide();
    //        $(this).closest('ul').find("li:hidden:first").show();
    //    }
    //});

    //$('.attachment-upload-section').on('click', '.remove-attachment-button', function (e) {
    //    e.preventDefault();
    //    if ($(".attachment-upload-section li:hidden").length || $(this).closest('ul').find("li:visible .input-addon").is(':visible')) {
    //        $(this).closest("li").hide();
    //        $(this).closest('ul').find("li:hidden:first .input-addon").show();
    //        $(this).closest("li").insertAfter($(this).closest('ul').find("li:last"));
    //    }
    //    else {
    //        $(this).closest("li").insertAfter($(this).closest('ul').find("li:last"));
    //        $(this).closest("li").find(".input-addon").show();
    //    }
    //});

    //var addAttachment = function () {
    //    $(".attachment-upload-section li:first-child").show();

    //    // $("#sharing_project_modal_form .attachment-upload-section").prepend('<li><div class="fileinput fileinput-new" data-provides="fileinput"><span class="input-addon btn btn-default btn-file"><span class="fileinput-new">Select file</span><span class="fileinput-exists">Select file</span><input type="file" id="[4]" class="file-input" name="Attachments"></span><span class="fileinput-filename"></span><a href="#" class="close fileinput-exists remove-attachment-button" data-dismiss="fileinput" style="float: none">&times;</a></div></li>');
    //    //$("button[type = 'hidden']").remove();

    //};


    $(document).on('submit', '.js-job-find-freelance-modal-form', function (e) {
        const $that = $(this);
        const $submitButton = $that.find("button[type='submit']");
        e.preventDefault();
        $submitButton.button('loading');

        let $formValidationContainer = $('.js-job-find-freelance-modal-form .js-validation-summary');
        let $formValidationReportList = $formValidationContainer.find('ul');
        $formValidationReportList.empty();
        $formValidationReportList.removeClass('validation-success');
        const successText = $('.js-job-find-freelance-modal-form-success');

        grecaptcha.ready(function () {
            // do request for recaptcha token
            const siteKey = $that.data("recaptchaSiteKey");

            grecaptcha.execute(siteKey, { action: 'findfreelance' }).then(function (token) {
                // add token to form
                $that.find(".js-recaptcha-token").val(token);

                let data = new FormData($that.get(0));

                $.ajax({
                    url: "/jobs/postfindfreelance",
                    type: 'POST',
                    data: data,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        if (data.success) {
                            $formValidationReportList.addClass('validation-success');
                            $formValidationReportList.append('<li>' + successText.html() + '</li>');
                            $that.get(0).reset();
                        }
                        else {

                            for (let i = 0; i < data.modelErrors.length; i++) {
                                $formValidationReportList.append('<li>' + data.modelErrors[i] + '</li>');
                            }
                        }
                        $submitButton.button('reset');
                        $formValidationReportList.focus();
                    },
                    error: function (data) {
                        console.log("Unexpected error occured while trying to transfer freelance request.");
                        $formValidationReportList.addClass('validation-error');
                        $formValidationReportList.append("<li>Une erreur innatendue est survenue. Votre demande n'a pas été transmise. Veuillez réessayer.</li>");
                        $submitButton.button('reset');
                        $formValidationReportList.focus();
                    },
                });

            });
        });
    });

    initForm();
});


function initForm() {
    $('.js-job-find-freelance-modal-form input[data-inputmask]').inputmask();
    $('.js-job-find-freelance-modal-form .file').fileinput();
}